import { render, staticRenderFns } from "./PDFModal.vue?vue&type=template&id=23ab1ab5&scoped=true&lang=pug&"
import script from "./PDFModal.vue?vue&type=script&lang=js&"
export * from "./PDFModal.vue?vue&type=script&lang=js&"
import style0 from "./PDFModal.vue?vue&type=style&index=0&id=23ab1ab5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab1ab5",
  null
  
)

export default component.exports